import $  from 'jquery';

function showAllCategories() {
    $('.js-categories').each(function () {
        const button = $(this).find('.js-all');
        const categories = $(this).find('.js-category-list');

        button.click(function () {
            categories.toggleClass('open');
        })
    })
}

function showModalCart() {
    const cartButton = $('.js-cart-button');
    const modalCart = $('.js-modal-cart');
    const closeModal = $('.js-close-modal');

    cartButton.click(function () {
        modalCart.toggle('open');
    })

    closeModal.click(function () {
        modalCart.css('display', 'none');
        $('.header-top__basket').removeClass('open');
    })
}

export {showAllCategories, showModalCart}